 
import {
    APPEND_DATA,
    RESET_DATA
} from "./actionTypes"

const INITIAL_STATE = {
    type:"add",
    editId:"",
    compound:null,
    currentImge:null,
    constrains:null,
    images:[],
    previousImg:null,
    masterImg:null
}

const modeReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case APPEND_DATA:
            return { ...state, ...action.payload}
        case RESET_DATA:
            return INITIAL_STATE
        default:
            return state
    }
}

export default modeReducer
